import { takeLatest } from "redux-saga/effects"
import {
  addCommentCalenderAction,
  AddMenuCategoryAction,
  addMenuItemsActions,
  DeleteMenuCategoryAction,
  deleteMenuItemAction,
  deleteRaffleContestAction,
  deleteWineMonthAction,
  EditCommentCalenderAction,
  EditMenuCategoryAction,
  editRaffleContestAction,
  editWineOfTheMonthItemAction,
  getBarMenuPeriodAction,
  getFoodItemsAction,
  getLeaderboardDataAction,
  getMenuPeriodAction,
  getRaffleListDataAction,
  getRaffleSingleDataAction,
  getSingleUserDataGraphAction,
  getSingleWineMonthDataAction,
  getWineMenuPeriodAction,
  getWineMonthAction,
  raffleTicketAction,
  updateFoodItemsAction,
  uploadMenuItemAction,
  uploadPDFThumbnailAction,
  uploadTastingNotesImagesAction,
  uploadWineOfTheMonthAction,
  WineMonthVideoThumbnailAction,
  addWineMenuItemsAction,
  getWineItemsAction,
  updateWineItemsAction,
  deleteWineItemAction,
  addBarMenuItemsAction,
  getBarItemsAction,
  updateBarItemsAction,
  deleteBarItemAction,
  getNewSpiritCountAction
} from "../actions"

import {
  addarchiveSpiritItems,
  AddBarMenuCategory,
  addBarMenuItems,
  addCommentCalender,
  addMenuCategory,
  addMenuItems,
  addWineMenuItems,
  deleteBarMenuCategory,
  deleteBarMenuItem,
  deleteMenuCategory,
  deleteMenuItem,
  deleteRaffleContest,
  deleteSpiritMenuItem,
  deleteWineMenuItem,
  deleteWineOfTheMonthItem,
  editBarMenuCategory,
  editBarMenuItem,
  EditCommentCalender,
  editMenuCategory,
  editRaffleContest,
  editWineMenuItem,
  editWineOfTheMonthItem,
  getArchivedSpiritCMS,
  getBarItems,
  getBarMenu,
  getFoodItems,
  getLeaderboardData,
  getListWineMonth,
  getMenuPeriod,
  getRaffleListData,
  getRaffleSingleData,
  getSingleUserDataGraph,
  getSingleWineMonthData,
  getSpiritCMS,
  getWineItems,
  getWineMenu,
  importSpiritItem,
  raffleTicket,
  unArchiveBarItems,
  unArchiveItems,
  unArchiveSpiritsItems,
  unarchiveWineItem,
  updateFoodItems,
  uploadMenuItem,
  uploadPDFThumbnail,
  uploadTastingNotesImages,
  uploadWineOfTheMonth,
  uploadWineOfTheMonthThumbnail,
  getSpiritItems,
  updateSpiritItems,
  getNewSpiritCount
} from "./user"
import {
  addarchiveSpiritItemsAction,
  AddBarMenuCategoryAction,
  archiveSpiritItemsAction,
  DeleteBarMenuCategoryAction,
  EditBarMenuCategoryAction,
  getArchivedSpiritCMSAction,
  getSpiritCMSAction,
  importSpiritItemAction,
  unArchiveBarItemsAction,
  unArchiveItemsAction,
  unArchiveSpiritsItemsAction,
  unarchiveWineItemsAction,
  deleteSpiritMenuItemAction,
  getSpiritItemsAction,
  updateSpiritItemsAction
} from "../actions/user"

export default function* marketingWatcher() {
  yield takeLatest(raffleTicketAction, raffleTicket)
  yield takeLatest(WineMonthVideoThumbnailAction, uploadWineOfTheMonthThumbnail)
  yield takeLatest(uploadWineOfTheMonthAction, uploadWineOfTheMonth)
  yield takeLatest(getWineMonthAction, getListWineMonth)
  yield takeLatest(deleteWineMonthAction, deleteWineOfTheMonthItem)
  yield takeLatest(getSingleWineMonthDataAction, getSingleWineMonthData)
  yield takeLatest(editWineOfTheMonthItemAction, editWineOfTheMonthItem)

  yield takeLatest(editRaffleContestAction, editRaffleContest)
  yield takeLatest(getRaffleListDataAction, getRaffleListData)
  yield takeLatest(deleteRaffleContestAction, deleteRaffleContest)
  yield takeLatest(getRaffleSingleDataAction, getRaffleSingleData)
  yield takeLatest(uploadPDFThumbnailAction, uploadPDFThumbnail)
  yield takeLatest(getMenuPeriodAction, getMenuPeriod)
  yield takeLatest(addCommentCalenderAction, addCommentCalender)
  yield takeLatest(EditCommentCalenderAction, EditCommentCalender)
  yield takeLatest(EditMenuCategoryAction, editMenuCategory)
  yield takeLatest(AddMenuCategoryAction, addMenuCategory)
  yield takeLatest(DeleteMenuCategoryAction, deleteMenuCategory)
  yield takeLatest(uploadMenuItemAction, uploadMenuItem)
  yield takeLatest(deleteMenuItemAction, deleteMenuItem)
  yield takeLatest(addMenuItemsActions, addMenuItems)
  yield takeLatest(getFoodItemsAction, getFoodItems)
  yield takeLatest(updateFoodItemsAction, updateFoodItems)
  yield takeLatest(uploadTastingNotesImagesAction, uploadTastingNotesImages)
  yield takeLatest(getLeaderboardDataAction, getLeaderboardData)
  yield takeLatest(getSingleUserDataGraphAction, getSingleUserDataGraph)
  yield takeLatest(getBarMenuPeriodAction, getBarMenu)
  yield takeLatest(getWineMenuPeriodAction, getWineMenu)
  yield takeLatest(addWineMenuItemsAction, addWineMenuItems)
  yield takeLatest(getWineItemsAction, getWineItems)
  yield takeLatest(updateWineItemsAction, editWineMenuItem)
  yield takeLatest(deleteWineItemAction, deleteWineMenuItem)
  yield takeLatest(addBarMenuItemsAction, addBarMenuItems)
  yield takeLatest(getBarItemsAction, getBarItems)
  yield takeLatest(updateBarItemsAction, editBarMenuItem)
  yield takeLatest(deleteBarItemAction, deleteBarMenuItem)
  yield takeLatest(AddBarMenuCategoryAction, AddBarMenuCategory)
  yield takeLatest(EditBarMenuCategoryAction, editBarMenuCategory)
  yield takeLatest(DeleteBarMenuCategoryAction, deleteBarMenuCategory)
  yield takeLatest(unArchiveItemsAction, unArchiveItems)
  yield takeLatest(unArchiveBarItemsAction, unArchiveBarItems)
  yield takeLatest(importSpiritItemAction, importSpiritItem)
  yield takeLatest(getSpiritCMSAction, getSpiritCMS)
  yield takeLatest(getArchivedSpiritCMSAction, getArchivedSpiritCMS)
  yield takeLatest(unArchiveSpiritsItemsAction, unArchiveSpiritsItems)
  yield takeLatest(archiveSpiritItemsAction, archiveSpiritItemsAction)
  yield takeLatest(unarchiveWineItemsAction, unarchiveWineItem)
  yield takeLatest(addarchiveSpiritItemsAction, addarchiveSpiritItems)
  yield takeLatest(deleteSpiritMenuItemAction, deleteSpiritMenuItem)
  yield takeLatest(getSpiritItemsAction, getSpiritItems)
  yield takeLatest(updateSpiritItemsAction, updateSpiritItems)
  yield takeLatest(getNewSpiritCountAction, getNewSpiritCount)
}
